import type { CardPaymentSystemConfig } from '../model/types';

export type CardPaymentSystemInfo = {
  name: string;
  icon: string;
};

export function getCardPaymentSystem(
  cardNumber: string,
  config: CardPaymentSystemConfig
): CardPaymentSystemInfo | undefined {
  const prefix = Object.keys(config).find(key => cardNumber.startsWith(key));

  return prefix ? config[prefix] : undefined;
}
